export default __webpack_public_path__ + "static/media/Zabbix.2b9ea506.svg";